import { Plugin } from '../../types';

export const scroll: Plugin = {
  name: 'scroll',
  page: (emit) => {
     window.document.addEventListener('scroll', () => {
      const now = Date.now()
      emit({
        coords: [window.pageXOffset, window.pageYOffset],
        time: now
      });
    });
    return () =>{ 
      // window.document.removeEventListener(listener)
    }
  },
  reduce: (previousEvents, event) => {
    /**@return Event[] */
    const previousEvent = previousEvents[previousEvents.length-1]
    if(!previousEvent){
      return [event]
    }
    if(previousEvent.name === 'scroll' && event.name === 'scroll'){
      return previousEvents.slice(0,-1).concat([{...event, time: previousEvent.time}])
    }
    return previousEvents.concat([event])
  },
  test: {
    matchers: {
      toScroll: async (page, x, y) => {
        try {
          await page.evaluate(`window.scrollTo(${x}, ${y})`);
          return { pass: true, message: () => "Page scrolled to " + x + ", " + y };
    
        } catch (err) {
          console.log(err)
          return {
            pass: false,
            message: () => "Page did not scroll successfully " + err,
          };
        }
      },
    }
  },
  generate(event) {
    return `
    it("scrolls the page", async ()=>{
      await expect(page).toScroll(${event.coords[0]},${event.coords[1]})
    })`
  },
};

export default scroll